import iconCode from "@core/assets/icons/careerPositions/code.svg?raw";
import iconDesign from "@core/assets/icons/careerPositions/design.svg?raw";
import iconTest from "@core/assets/icons/careerPositions/test.svg?raw";
import type { CareerPositionIconKey } from "./careerPositions.js";

export const careerPositionIconByKey = {
	code: iconCode,
	design: iconDesign,
	test: iconTest,
} satisfies Record<CareerPositionIconKey, string>;
